import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { ArrowRightIcon, CheckIcon, MenuIcon, ShoppingCartIcon } from 'lucide-react';
import { useCart } from '../../contexts/CartContext';
import { livingNav, livingUsps } from '../../data/navigation';
import { Logo } from '../brand/Logo';
import { SearchBox } from '../layout/SearchBox';
import { MobileMenu } from '../layout/MobileMenu';
export function LivingHeader() {
  const {
    count,
    open
  } = useCart();
  const [menuOpen, setMenuOpen] = useState(false);
  const primary = livingNav.slice(0, 5);
  const secondary = livingNav.slice(5);
  const linkClass = ({
    isActive
  }: {
    isActive: boolean;
  }) => `whitespace-nowrap text-[15px] font-semibold transition-colors duration-150 ${isActive ? 'text-majorelle' : 'text-ink hover:text-majorelle'}`;
  return <>
      <header className="sticky top-0 z-40 bg-white" data-id="element-329" data-mp="cx4zarqk7dmp">
        <div className="bg-majorelle text-white" data-id="element-330" data-mp="7zlaixw8jigi">
          <div className="mx-auto flex h-10 max-w-7xl items-center justify-between gap-6 px-5 text-[13px] font-medium lg:px-8" data-id="element-331" data-mp="7ytq8j83975j">
            <ul className="flex items-center gap-6" data-id="element-332" data-mp="1u0rj4uuzt8tw">
              {livingUsps.map((u, i) => <li key={u} className={`items-center gap-1.5 whitespace-nowrap ${i === 0 ? 'flex' : 'hidden md:flex'}`} data-id="element-333" data-mp="1y1t8mjz3y6io" data-mpi={i}>
                  <CheckIcon className="h-3.5 w-3.5" strokeWidth={2.5} aria-hidden="true" data-id="element-334" data-mp="27tpjkvmalr4b" />
                  {u}
                </li>)}
            </ul>
            <Link to="/" className="flex shrink-0 items-center gap-1.5 whitespace-nowrap text-white/85 transition-colors duration-150 hover:text-white" data-id="element-335" data-mp="1b5t1tnf4cpri">
              AMIRA Beauty
              <ArrowRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-336" data-mp="1k2tmbiz2i3po" />
            </Link>
          </div>
        </div>

        <div className="border-b border-line" data-id="element-337" data-mp="1p1emjiebkne4">
          <div className="mx-auto flex h-16 max-w-7xl items-center gap-3 px-5 lg:h-20 lg:gap-10 lg:px-8" data-id="element-338" data-mp="2vkcttnjoksu1">
            <button type="button" onClick={() => setMenuOpen(true)} className="-ml-2 grid h-10 w-10 place-items-center lg:hidden" aria-label="Menu openen" data-id="element-339" data-mp="30hlga0bv3j13">
              <MenuIcon className="h-5 w-5" data-id="element-340" data-mp="25vfvkft1n97e" />
            </button>
            <Link to="/living" aria-label="AMIRA Living, naar home" className="shrink-0" data-id="element-341" data-mp="25uwf73j1ksvh">
              <Logo sub="LIVING" data-id="element-342" data-mp="2ks6k1u16j0i8" />
            </Link>
            <div className="mx-auto hidden w-full max-w-2xl md:block" data-id="element-343" data-mp="2ftvbrnqj8y24">
              <SearchBox line="living" data-id="element-344" data-mp="2friyhnvpzbve" />
            </div>
            <button type="button" onClick={open} className="ml-auto flex h-11 shrink-0 items-center gap-2 rounded-full bg-terracotta pl-4 pr-2 text-sm font-semibold text-white transition-colors duration-150 hover:bg-terracotta-dark md:ml-0" aria-label={`Winkelwagen, ${count} artikelen`} data-id="element-345" data-mp="1s52m290i7mfy">
              <ShoppingCartIcon className="h-4 w-4" aria-hidden="true" data-id="element-346" data-mp="19djk85i7uefi" />
              <span className="hidden sm:inline" data-id="element-347" data-mp="19bf6ywyfg32k">Winkelwagen</span>
              <span className="grid h-7 min-w-7 place-items-center rounded-full bg-white/20 px-1.5 text-xs tabular-nums" data-id="element-348" data-mp="14ddmc7lcrvoz">{count}</span>
            </button>
          </div>
          <div className="px-5 pb-3 md:hidden" data-id="element-349" data-mp="3kt0kwmzz5xor">
            <SearchBox line="living" data-id="element-350" data-mp="3kttj2zkvbeva" />
          </div>
        </div>

        <nav aria-label="Categorieën" className="hidden border-b border-line lg:block" data-id="element-351" data-mp="364dxdy071zmg">
          <div className="mx-auto flex h-12 max-w-7xl items-center justify-between px-8" data-id="element-352" data-mp="3b25ud6fp4bxi">
            <ul className="flex items-center gap-9" data-id="element-353" data-mp="2mdv8zhbkogr">
              {primary.map(item => <li key={item.to} data-id="element-354" data-mp="7lqg5eomrlgp">
                  <NavLink to={item.to} className={linkClass} data-id="element-355" data-mp="7knsdfmltz50">{item.label}</NavLink>
                </li>)}
            </ul>
            <ul className="flex items-center gap-9" data-id="element-356" data-mp="3pty14u1fchnm">
              {secondary.map(item => <li key={item.to} data-id="element-357" data-mp="3tv9r50o7n4wc">
                  <NavLink to={item.to} className={linkClass} data-id="element-358" data-mp="2ebwy5v1z3ice">{item.label}</NavLink>
                </li>)}
            </ul>
          </div>
        </nav>
      </header>

      <MobileMenu open={menuOpen} onClose={() => setMenuOpen(false)} line="living" data-id="element-359" data-mp="2yl697vnh9p9b" />
    </>;
}